<div class="grid-x grid-margin-x section">
  <form [formGroup]="form">
    @if (hasFieldNotes('apiNumber')) {
      <div>
        <view-notes [fieldName]="'apiNumber'" [notes]="getFilteredNotes('apiNumber')" (notesRequested)="handleNotesRequested($event)"></view-notes>
      </div>
    }
    <well-selector [organization]="organization" [enableSelections]="enableWellSelection" [reportType]="reportType" (throw)="handleError($event)" (selectedWells)="onWellsSelected($event)"></well-selector>
    @if (wellIsSelected) {
      @if (!filesUploaded && wellIsSelected) {
        @if (!isInFracFocus) {
          <div class="checkbox">
            @if (hasFieldNotes('hasNoStimAdditives') || isInReview) {
              <span>
                <view-notes [fieldName]="'hasNoStimAdditives'" [notes]="getFilteredNotes('hasNoStimAdditives')" (notesRequested)="handleNotesRequested($event)"></view-notes>
              </span>
            }
            <input class="show-for-sr" id="hasNoStimAdditives" type="checkbox" formControlName="hasNoStimAdditives" (change)="onHasAdditivesClicked($event)" />
            <label for="hasNoStimAdditives">
              No stimulation additives were used. Form 8B not applicable.
              <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span>
            </label>
          </div>
        }
        @if (!hasNoAdditives) {
          <div class="checkbox">
            @if (hasFieldNotes('isInFracFocus') || isInReview) {
              <span>
                <view-notes [fieldName]="'isInFracFocus'" [notes]="getFilteredNotes('isInFracFocus')" (notesRequested)="handleNotesRequested($event)"></view-notes>
              </span>
            }
            <input class="show-for-sr" id="isInFracFocus" type="checkbox" formControlName="isInFracFocus" (change)="onIsInFracClicked($event)" />
            <label for="isInFracFocus">
              Stimulation additives submitted to FracFocus.
              <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span>
            </label>
          </div>
        }
      }
      @if (isInternal) {
        <label for="receivedDate">Form 8B Received Date</label>
        <common-date-picker [id]="'receivedDate'" (dateUpdated)="onDateUpdated($event, 'receivedDate')" [initialDate]="receivedDate" [disabled]="form?.get('receivedDate')?.disabled"></common-date-picker>
        <label for="plugDate">Form 8B FracFocus Date</label>
        <common-date-picker [id]="'fracFocusDate'" (dateUpdated)="onDateUpdated($event, 'fracFocusDate')" [initialDate]="fracFocusDate" [disabled]="form?.get('fracFocusDate')?.disabled"></common-date-picker>
        <label for="replugDate">Form 8B N/A Date</label>
        <common-date-picker [id]="'nonAppDate'" (dateUpdated)="onDateUpdated($event, 'nonAppDate')" [initialDate]="nonAppDate" [disabled]="form?.get('nonAppDate')?.disabled"></common-date-picker>
      }
      @if (hasNoAdditives == false && isInFracFocus == false) {
        <div class="grid-x grid-margin-x padding-bottom-large section">
          <div class="cell small-12 medium-12 large-12 bold">
            Upload Form 8B Well Stimulation Additives Report: <span class="bold">*</span>
          </div>
          <div class="cell small-12 medium-12 large-12">
            @if (hasFieldNotes('uploadedFiles')) {
              <span> <view-notes [fieldName]="'uploadedFiles'" [notes]="getFilteredNotes('uploadedFiles')" (notesRequested)="handleNotesRequested($event)"></view-notes></span>
            }
            <upload-view-files [uniqueId]="'uploader'" [files]="uploadedFiles" [isPadded]="false" [componentLabel]="''" [showFileList]="true" [allowDeletion]="uploadedFilesCtrl?.enabled" [allowUpload]="uploadedFilesCtrl?.enabled" (fileRemoved)="onFileDeleted($event)" (newFilesList)="fileAdded($event)">
            </upload-view-files>
          </div>
        </div>
      }
      @if (!isInReview && wellIsSelected) {
        <div class="grid-x grid-margin-x ">
          @switch (true) {
            @case (!isInternal) {
              <div class="large-12 medium-12 small-12 text-align-center">
                <p>By clicking submit, I certify that the information provided is true and accurate, to the best of my knowledge.</p>
                <span class="minor-margin-right">
                  <button class="button" (click)="saveForLater()">Save for Later</button>
                </span>
                <ng-container>
                  <span class="minor-margin-right">
                    <button class="button" [disabled]="disableSubmit" (click)="submit()">Submit</button>
                  </span>
                </ng-container>
                <span>
                  <button class="button" (click)="cancel()">Cancel</button>
                </span>
              </div>
            }
            @case (isInternal) {
              <div class="large-12 medium-12 small-12 text-align-center">
                @if (!isApproved && !isInCorrections) {
                  <span class="minor-margin-right">
                    <button class="button" (click)="saveForLater()">Save for Later</button>
                  </span>
                }
                @if (!isApproved && !isInCorrections) {
                  <span class="minor-margin-right">
                    <button class="button" [disabled]="disableSubmit" (click)="onAccept()">Accept</button>
                  </span>
                }
                <span>
                  <button class="button" (click)="cancel()">Cancel</button>
                </span>
              </div>
            }
          }
        </div>
      }
    }

  </form>
</div>


